import React from 'react';
import './sub-nav.css';


const SubNav = ({ filterPhotos, navigationItems }) => {

	// Navigation -- Displays menu items
	// 	-- activate menu item button
	// -- on click filters photos

	// Function to activate the navigation button
	const activateButton = (id) => {
		const activate = document.getElementById(id);
		const deactivate = document.getElementsByClassName('cat active-photos');
		if (deactivate) {
			for (let i = 0; i < deactivate.length; i++) {
	 			if (deactivate[i].className === "cat active-photos")
					{
						deactivate[i].className = 'cat inactive-photos';
					}
			}
		}
		else {
			console.log('did not receive any tags for deactivation');
		}
		if (activate) {
			activate.className = 'cat active-photos';
		}
		else {
			console.log('activate is null');
		}
	}

	return (
		<main>
			<ul>
				{
					navigationItems.map(item => {
						return (<li key={item.label} id={item.label} className='cat'>
									<p onClick = {() => {
										activateButton(item.label);
										filterPhotos(item.label);
									}
									}>{item.label}
									</p>
								</li>)
					})
				}
			</ul>
		</main>
	)
}

export default SubNav;